"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.syntheticProcess = exports.remove = exports.add = exports.createBusUploadToDatalakeArtifact = void 0;
const uuid_1 = require("uuid");
const helpers_1 = require("./helpers");
const dbNodes = __importStar(require("../dbNodes/dbNodes"));
const utils = __importStar(require("../dbNodes/utils"));
// The BUS datalake upload. A deal opts in with `enableDataLake` on its
// reconcile node (absent = off, so graphs saved before the flag stay as they
// were). The upload's inputs are fixed by that node, so nothing is authored in
// the UI: it reads the tape reconcile checked (`dataTapeSlug`) and must run
// after the approval gate, so the lake only ever holds accepted data.
//
// Before:
// +-----------+     +--------------------+
// | data tape +---->|  reconciledBusTape |
// +-----------+     +--------------------+
//
// After (the approval gate, a later step, then interposes on the
// reconcile => upload edge):
// +-----------+     +--------------------+     +---------------------+
// | data tape +---->|  reconciledBusTape +---->| busUploadToDatalake |
// +-----+-----+     +--------------------+     +----------+----------+
//       |                                                 ^
//       +-------------------------------------------------+
const createBusUploadToDatalakeArtifact = ({ referenceArtifact, }) => ({
    id: (0, uuid_1.v4)(),
    type: dbNodes.busUploadToDatalake.artifactType,
    configuration: {},
    loanProductSlug: null,
    creditFacilitySlug: null,
    artifactDocumentId: referenceArtifact.artifactDocumentId,
    externalFilename: null,
    // Stable across saves (the id is reminted each time): run history and
    // artifact instances match nodes by slug.
    artifactSlug: `busUploadToDatalake_${referenceArtifact.artifactSlug}`,
});
exports.createBusUploadToDatalakeArtifact = createBusUploadToDatalakeArtifact;
const add = (dbGraph) => {
    const uploads = [];
    const edges = [];
    utils
        .filterReconciledBusTapes(dbGraph)
        .filter(({ configuration }) => configuration.enableDataLake === true)
        .forEach((reconcile) => {
        const dataTape = utils.findArtifactBySlug({
            dataTapes: dbGraph.dataTapes,
            artifactSlug: reconcile.configuration.dataTapeSlug,
        });
        const upload = (0, exports.createBusUploadToDatalakeArtifact)({
            referenceArtifact: reconcile,
        });
        uploads.push(upload);
        edges.push({ inputArtifactId: reconcile.id, outputArtifactId: upload.id }, { inputArtifactId: dataTape.id, outputArtifactId: upload.id });
    });
    return {
        dataTapes: [...dbGraph.dataTapes, ...uploads],
        dataTapeDependencies: [...dbGraph.dataTapeDependencies, ...edges],
    };
};
exports.add = add;
// Inverse of `add`: the uploads are fully derived from the reconcile config,
// so dropping them and their edges restores the graph exactly.
const remove = (dbGraph) => (0, helpers_1.removeNodesAndIncidentEdges)(dbGraph, utils.filterBusUploadToDatalakes(dbGraph).map(({ id }) => id));
exports.remove = remove;
exports.syntheticProcess = {
    toDb: exports.add,
    fromDb: exports.remove,
};
//# sourceMappingURL=busUploadToDatalake.js.map